"use client";

import { useState, useTransition } from "react";
import { resetPasswordToDefault } from "@/actions/admin";
import { Sheet } from "./sheet";
import { Button, ErrorText } from "./ui";

export function PasswordResetButton({
  memberId,
  displayName,
}: {
  memberId: string;
  displayName: string;
}) {
  const [open, setOpen] = useState(false);
  /** 초기화로 만들어진 임시 비밀번호. 다시 볼 수 없으니 이 자리에서 전해야 한다. */
  const [issued, setIssued] = useState<string | null>(null);
  const [error, setError] = useState("");
  const [pending, start] = useTransition();

  function openSheet() {
    setIssued(null);
    setError("");
    setOpen(true);
  }

  function reset() {
    setError("");
    start(async () => {
      const result = await resetPasswordToDefault(memberId);
      if (!result.ok) {
        setError(result.error);
        return;
      }
      setIssued(result.temporaryPassword);
    });
  }

  return (
    <>
      <button
        type="button"
        onClick={openSheet}
        className="shrink-0 rounded-lg bg-surface-2 px-3 py-1.5 text-[13px] font-bold text-danger"
      >
        비밀번호 초기화
      </button>

      <Sheet
        open={open}
        onClose={() => setOpen(false)}
        title="비밀번호 초기화"
        dismissible={!pending}
      >
        {issued ? (
          <>
            <p className="mt-5 text-[15px] leading-relaxed text-fg-2">
              {displayName} 님의 임시 비밀번호예요. 지금 전해주세요 — 이 창을 닫으면 다시 볼 수
              없어요.
            </p>
            <p className="mt-3 select-all rounded-2xl bg-surface-2 px-4 py-4 text-center font-mono text-[22px] font-bold tracking-[0.2em] text-fg">
              {issued}
            </p>
            <p className="mt-3 text-[14px] leading-relaxed text-muted">
              이 비밀번호로 로그인하면 새 비밀번호를 정하는 화면이 먼저 뜨고, 정하기 전에는 앱을
              쓸 수 없어요.
            </p>
            <div className="mt-6">
              <Button full onClick={() => setOpen(false)}>
                확인
              </Button>
            </div>
          </>
        ) : (
          <>
            <p className="mt-5 text-[15px] leading-relaxed text-fg-2">
              {displayName} 님의 비밀번호를 임시 비밀번호로 초기화할까요?
            </p>
            <p className="mt-2 text-[14px] leading-relaxed text-muted">
              한 번만 쓰는 임시 비밀번호를 만들어 보여드려요. 현재 로그인된 기기는 모두
              로그아웃됩니다.
            </p>

            <ErrorText>{error}</ErrorText>

            <div className="mt-6 space-y-2">
              <Button full disabled={pending} onClick={reset}>
                {pending ? "초기화하는 중…" : "임시 비밀번호 발급"}
              </Button>
              <Button
                type="button"
                full
                variant="ghost"
                disabled={pending}
                onClick={() => setOpen(false)}
              >
                취소
              </Button>
            </div>
          </>
        )}
      </Sheet>
    </>
  );
}
